const TRANSLATION_PREFIX = 'STATIC.PAGES.AI_CONTEXT';

const sectionKey = (sectionId, field) => `${TRANSLATION_PREFIX}.SECTIONS.${sectionId}.${field}`;
const questionKey = (questionId, field) => `${TRANSLATION_PREFIX}.QUESTIONS.${questionId}.${field}`;

export const SECTIONS = [
    {
        id: 'strategy',
        name: sectionKey('STRATEGY', 'NAME'),
        description: sectionKey('STRATEGY', 'DESCRIPTION'),
        icon: 'target',
        questions: [
            {
                id: 'optimization_approach',
                title: questionKey('OPTIMIZATION_APPROACH', 'TITLE'),
                description: questionKey('OPTIMIZATION_APPROACH', 'DESCRIPTION'),
                placeholder: questionKey('OPTIMIZATION_APPROACH', 'PLACEHOLDER'),
            },
            {
                id: 'budget_allocation',
                title: questionKey('BUDGET_ALLOCATION', 'TITLE'),
                description: questionKey('BUDGET_ALLOCATION', 'DESCRIPTION'),
                placeholder: questionKey('BUDGET_ALLOCATION', 'PLACEHOLDER'),
            },
        ],
    },
    {
        id: 'metrics',
        name: sectionKey('METRICS', 'NAME'),
        description: sectionKey('METRICS', 'DESCRIPTION'),
        icon: 'chart-bar',
        questions: [
            {
                id: 'key_metrics',
                title: questionKey('KEY_METRICS', 'TITLE'),
                description: questionKey('KEY_METRICS', 'DESCRIPTION'),
                placeholder: questionKey('KEY_METRICS', 'PLACEHOLDER'),
            },
            {
                id: 'monetization_model',
                title: questionKey('MONETIZATION_MODEL', 'TITLE'),
                description: questionKey('MONETIZATION_MODEL', 'DESCRIPTION'),
                placeholder: questionKey('MONETIZATION_MODEL', 'PLACEHOLDER'),
            },
            {
                id: 'attention_triggers',
                title: questionKey('ATTENTION_TRIGGERS', 'TITLE'),
                description: questionKey('ATTENTION_TRIGGERS', 'DESCRIPTION'),
                placeholder: questionKey('ATTENTION_TRIGGERS', 'PLACEHOLDER'),
            },
        ],
    },
    {
        id: 'operations',
        name: sectionKey('OPERATIONS', 'NAME'),
        description: sectionKey('OPERATIONS', 'DESCRIPTION'),
        icon: 'adjustments',
        questions: [
            {
                id: 'root_cause_analysis',
                title: questionKey('ROOT_CAUSE_ANALYSIS', 'TITLE'),
                description: questionKey('ROOT_CAUSE_ANALYSIS', 'DESCRIPTION'),
                placeholder: questionKey('ROOT_CAUSE_ANALYSIS', 'PLACEHOLDER'),
            },
            {
                id: 'constraints',
                title: questionKey('CONSTRAINTS', 'TITLE'),
                description: questionKey('CONSTRAINTS', 'DESCRIPTION'),
                placeholder: questionKey('CONSTRAINTS', 'PLACEHOLDER'),
            },
            {
                id: 'creative_optimization',
                title: questionKey('CREATIVE_OPTIMIZATION', 'TITLE'),
                description: questionKey('CREATIVE_OPTIMIZATION', 'DESCRIPTION'),
                placeholder: questionKey('CREATIVE_OPTIMIZATION', 'PLACEHOLDER'),
            },
            {
                id: 'weekly_summary',
                title: questionKey('WEEKLY_SUMMARY', 'TITLE'),
                description: questionKey('WEEKLY_SUMMARY', 'DESCRIPTION'),
                placeholder: questionKey('WEEKLY_SUMMARY', 'PLACEHOLDER'),
            },
        ],
    },
    {
        id: 'additional_context',
        name: sectionKey('ADDITIONAL_CONTEXT', 'NAME'),
        description: sectionKey('ADDITIONAL_CONTEXT', 'DESCRIPTION'),
        icon: 'bulb',
        questions: [
            {
                id: 'other',
                title: questionKey('OTHER', 'TITLE'),
                description: questionKey('OTHER', 'DESCRIPTION'),
                placeholder: questionKey('OTHER', 'PLACEHOLDER'),
            },
            {
                id: 'reference_links',
                kind: 'reference_links',
                title: questionKey('REFERENCE_LINKS', 'TITLE'),
                description: questionKey('REFERENCE_LINKS', 'DESCRIPTION'),
            },
        ],
    },
];

export const ALL_QUESTIONS_COUNT = SECTIONS.reduce((total, section) => total + section.questions.length, 0);

export const TOAST_CONFIG = { autoClose: 5000 };

export const REFERENCE_LINKS_QUESTION_ID = 'reference_links';
export const REFERENCE_LINKS_MAX_COUNT = 3;
export const REFERENCE_LINK_URL_MAX_LENGTH = 2000;
export const REFERENCE_LINK_DESCRIPTION_MAX_LENGTH = 200;
export const REFERENCE_LINK_URL_PATTERN = /^https:\/\/(?:docs|sheets)\.google\.com\/(?:document|spreadsheets)\//i;
